import { LegacyGlobalGlomInterface } from './Interface/Glom';
import { glom } from '../../../Signage/glom';
import { getPostbackUrl, isInsideCms } from '../../../Signage/urlOverrides';

export const GlobalGlom: LegacyGlobalGlomInterface = {
    get alertConfigId() {
        return glom.alertConfigId;
    },
    get weatherAlertConfigurationId() {
        return glom.weatherAlertConfigurationId;
    },
    get titleId() {
        return glom.titleId;
    },
    get originalTitle() {
        return glom.originalTitle;
    },
    get locale() {
        return glom.locale;
    },
    get windowScale() {
        return glom.windowScale;
    },
    get effectiveWindowScale() {
        return glom.effectiveWindowScale;
    },
    get insideCMS() {
        return isInsideCms();
    },
    get postbackURL() {
        return getPostbackUrl();
    },
    get playerXDimension() {
        return glom.playerXDimension;
    },
    get playerYDimension() {
        return glom.playerYDimension;
    },
    get debug() {
        return false;
    },
    get playerUuid() {
        return glom.playerUuid;
    },
    get securityToken() {
        return glom.securityToken;
    },
    dailyRestartWindow: {
        get begin() {
            return glom.dailyRestartWindow.begin;
        },
        get end() {
            return glom.dailyRestartWindow.end;
        },
    },
    get maxLoopSlots() {
        return glom.maxLoopSlots;
    },
    get timezone() {
        return glom.timezone;
    },
    get allowCursor() {
        return glom.allowCursor;
    },
    get showNetworkStates() {
        return glom.showNetworkStates;
    },
    get prefetchAssets() {
        return glom.prefetchAssets;
    },
};
